import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SliderModule } from 'primeng/slider';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TabHeaderComponent } from './tab-header/tab-header.component';
import { DropdownModule } from 'primeng/dropdown';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SliderModule,
    RadioButtonModule,
    DropdownModule
  ],
  declarations: [TabHeaderComponent],
  exports: [TabHeaderComponent]
})
export class TabHeaderModule { }
